<div class="input-group mb-2">
  <label class="input-group-text" for="agenciesFilter"><span class="visually-hidden">Filter by</span> LE Agency</label>
  <ng-container *ngIf="agencies$ | async as agencies">
    <p-multiSelect #agencyms id="agenciesFilter" [(ngModel)]="sAgencies" [options]="agencies" optionLabel="AgencyName" name="AgencyName" placeholder="All" dataKey="AgencyID" inputId="agenciesFilter" styleClass="form-select" ariaFilterLabel="Filter by agency name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectAgencies($event)" [resetFilterOnHide]="true" filterBy="AgencyName" [virtualScroll]="true" [virtualScrollItemSize]="30" appendTo="body">
      <ng-template let-selectedAgencies pTemplate="selectedItems">
        <ng-container *ngIf="selectedAgencies?.length <= 3">
          <span *ngFor="let agency of selectedAgencies; last as isLast">{{agency.AgencyName}}<span *ngIf="!isLast">;&nbsp;</span> </span>
        </ng-container>
        <ng-container *ngIf="selectedAgencies?.length > 3">{{ selectedAgencies.length }} items selected</ng-container>
        <ng-container *ngIf="!selectedAgencies || selectedAgencies?.length === 0">All</ng-container>
      </ng-template>
    </p-multiSelect>
  </ng-container>
</div>
